import { IdentifiableBase } from './identifiable-base.model';
import { DateString } from './date.model';

export interface Person extends IdentifiableBase {
  fullName: string;
  firstName: string;
  lastName: string;
  cnp: string;
  idNumber: string;
  idSeries: string;
  idIssuer: string;
  idIssueDate: DateString;
  idExpiryDate: DateString;
  dateOfBirth: DateString;
  phoneNumber?: string;
  mobilePhoneNumber: string;
  email: string;
  nationality?: string;
  idCard: string;

  address: Address;
}

export interface Address {
  postalCode?: string;
  city: string;
  county: string;
  streetName: string;
  streetNumber: string;
  buildingNumber?: string;
  entranceNumber?: string;
  floor?: string;
  apartment?: string;
}

export class AddressImpl implements Address{
  postalCode ='';
  city ='';
  county ='';
  streetName ='';
  streetNumber ='';
  buildingNumber ='';
  entranceNumber ='';
  floor ='';
  apartment ='';
}
